import { defineStore } from 'pinia'
import { ref } from 'vue'

class GlobalStore {
  isToggled = ref(true)
  isSmallScreen = ref(false)
  loading = ref(false)

  currentVisitId = ref<number | null>(null)

  selectedBranchId = ref<number | null>(null)

  toggleSidebar = () => {
    this.isToggled.value = !this.isToggled.value
    if (typeof window !== 'undefined') {
      localStorage.setItem('isToggled', this.isToggled.value.toString())
    }
  }
}

export const useGlobalStore = defineStore('global', () => new GlobalStore())
